export const CHANGE_KHP_VALUE = 'CHANGE_KHP_VALUE';
export const CHANGE_KHP_SEVERAL_VALUES = 'CHANGE_KHP_SEVERAL_VALUES';
export const RESET_KHP_STORE = 'RESET_KHP_STORE';

export const changeKHPValue = (key, value) => ({
  type: CHANGE_KHP_VALUE,
  payload: { key, value },
});

export const changeKHPSeveralValues = value => ({
  type: CHANGE_KHP_SEVERAL_VALUES,
  payload: value,
});

export const resetStore = () => ({
  type: RESET_KHP_STORE,
});
